import React, {lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ChoicesProvider } from '../context/ChoicesContext'; 
import loading from '../gif/loading.gif';

const Dictionary = lazy(() => import('../pages/Dictionary/Dictionary'));
const DictionaryFood = lazy(() => import('../pages/Dictionary/DictionaryFood'));
const DictionaryClothes = lazy(() => import('../pages/Dictionary/DictionaryClothes'));
const DictionaryFamily = lazy(() => import('../pages/Dictionary/DictionaryFamily'));
const DictionaryNumbers = lazy(() => import('../pages/Dictionary/DictionaryNumbers'));
const DictionaryColors = lazy(()=>import('../pages/Dictionary/DictionaryColors'));
const DictionaryBody = lazy(()=> import('../pages/Dictionary/DictionaryBody'));
const DictionaryAnimals = lazy(()=>import('../pages/Dictionary/DictionaryAnimals'));
const DictionaryFeelings = lazy(()=> import('../pages/Dictionary/DictionaryFeelings'));
const Tasks = lazy(() => import('../pages/Tasks/Tasks'));
const TaskFood = lazy(() => import('../pages/Tasks/TaskFood'));
const TaskClothes = lazy(() => import('../pages/Tasks/TaskClothes'));
const TaskFamily = lazy(() => import('../pages/Tasks/TaskFamily'));
const TaskNumbers= lazy(()=>import('../pages/Tasks/TaskNumbers'));
const TaskColors = lazy(()=> import('../pages/Tasks/TaskColors'));
const TaskBody = lazy(()=> import('../pages/Tasks/TaskBody'));
const TaskAnimals = lazy(()=> import('../pages/Tasks/TaskAnimals'));
const TaskFeelings = lazy(()=> import('../pages/Tasks/TaskFeelings'));

const AppRoutes = () => (
<ChoicesProvider>
    <Suspense fallback={<img src={loading} alt="Loading..." className="gif-loading" />}>
      <Routes>
        <Route path="/" element={null} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/dictionary" element={<Dictionary />} />
        <Route path="/dictionaryFood" element={<DictionaryFood />} />
        <Route path="/dictionaryClothes" element={<DictionaryClothes />} />
        <Route path="/dictionaryFamily" element={<DictionaryFamily />} />
        <Route path="/dictionaryNumbers" element={<DictionaryNumbers />} />
        <Route path="/dictionaryColors" element={<DictionaryColors />} />
        <Route path="/dictionaryBody" element={<DictionaryBody/>}/>
        <Route path="/dictionaryAnimals" element={<DictionaryAnimals />} />
        <Route path="/dictionaryFeelings" element={<DictionaryFeelings/>}/>
        <Route path="/taskFood" element={<TaskFood />} />
        <Route path="/taskClothes" element={<TaskClothes />} />
        <Route path="/taskFamily" element={<TaskFamily />} />
        <Route path="/taskNumbers" element={<TaskNumbers/>}/>
        <Route path="/taskColors" element={<TaskColors/>}/>
        <Route path="/taskBody" element={<TaskBody/>}/>
        <Route path="/taskAnimals" element={<TaskAnimals/>}/>
        <Route path="/taskFeelings" element={<TaskFeelings/>}/>
      </Routes>
    </Suspense>
</ChoicesProvider>
);

export default AppRoutes;